import { api } from '../api'

export const createPlayerDefaultSitDown = async (tableId: string): Promise<void> =>
  await api().url(`/api/assessment/${tableId}/default-sit-down`).get().json()
